import {
  setIframeStyle,
  getTdsConfig,
  initPaayTds,
  submitTdsTransaction
} from './utils/paay-utils';


const paayService = ({ order: orderDetails, tdsProviderDetails }) => {
  /** Merchants can elect to continue transaction without 3ds authorization. */
  const continueTransactionOnFail = tdsProviderDetails.threeDsByPassOnProviderFailure;

  const paayTdsConfig = getTdsConfig(tdsProviderDetails, setIframeStyle);

  const paayTds = initPaayTds(paayTdsConfig);

  return {
    submitTdsTransaction: submitTdsTransaction(paayTds, continueTransactionOnFail, orderDetails)
  };
};

export default paayService;
